export const en = {
  welcome: 'welcome',
  logout: 'logout',
  trading_accounts: 'trading accounts',
  account_list: 'account list',
  create_live_account: 'create live account',
  upgrade_to_live_account: 'upgrade to live account',
  create_demo_account: 'create demo account',
  finance: 'finance',
  deposit_funds: 'deposit funds',
  withdraw_funds: 'withdraw funds',
  internal_transfer: 'internal transfer',
  external_transfer: 'external transfer',
  transfer_back: 'transfer back',
  transfer_back_to_my_local_depositor: 'transfer back to my local depositor',
  transfer_to_external_account: 'transfer to external account',
  payment_history: 'payment history',
  my_cards: 'my cards',
  my_profile: 'my profile',
  personal_information: 'personal information',
  change_password: 'change password',
  upload_documents: 'upload documents',
  partner: 'partner',
  overview: 'overview',
  clients: 'clients',
  sub_ibs: 'sub ibs',
  payout: 'payout',
  marketing_material: 'marketing material',
  withdrawal_history: 'withdrawal history',
  become_a_partner: 'become a partner',
  please_fill_the_following_fields: 'please fill the following fields',
  what_geographic_region: 'What geographic region you will be mainly targeting?',
  submit: 'submit',
  upload_documents_notice: 'In order to fully approve your account and be able to trade, <a>please upload your documents</a> and complete your profile',
  change_password_ta_notice: 'Any new trading account will use your new password. This does not affect your current trading accounts.',
  changepass_error: 'Current password is wrong, please try again.',
  changepass_success: 'Password changed successfully',
  current_password: 'current password',
  new_password: 'new password',
  confirm_new_password: 'confirm new password',
  pending_account: 'pending account',
  account_must_be_approved_message: 'Your account must be approved prior to creating a new live trading account.',
  new_trading_account_message: 'New trading account created successfully',
  password_generated_for_ta: 'A password was generated and sent to your email for your new trading account',
  new_trading_account_type_message: 'New {type} trading account created successfully',
  choose_your_desired_trading_platform_and_settings: 'Choose your desired trading platform and settings',
  select_leverage: 'select leverage',
  create: 'create',
  select_account_type: 'select account type',
  select_currency: 'select currency',
  no_trading_account_found: 'No trading account found.',
  bankwire_notice:
    'Thank you for submitting your bank details. We will register your details with our bank.<br><br>You will receive the wire details via email within 24 hours alongside your personal payment reference. You can use these details for any future deposits.<br><br><strong>IMPORTANT:</strong> The payment reference is personalized for one client. If you do not use the payment reference you receive, we will not be able to accept your deposit. No third parties are able to use the same payment reference.',
  deposit: 'deposit',
  account_details: 'account details',
  enter_fasapay_id: 'Please enter your Fasapay Account ID:',
  account_id: 'Account ID',
  secure_id: 'Secure ID',
  continue: 'continue',
  // bankwire_details_notice: 'Our bank requires your bank details in order to process your deposit. Any deposits made via Wire Transfer will be returned to the same account from which you deposited.',
  bankwire_deposit_details_notice:
    'Our bank requires your bank details in order to process your deposit. Any deposits made via Wire Transfer will be returned to the same account from which you deposited.',
  bankwire_withdrawal_details_notice:
    'Our bank requires your bank details in order to process your withdrawal. Any withdrawals made via Wire Transfer will be returned to the same account from which you deposited.',
  bankwire_verify_account_notice: '<p>You need to verify your account before using Bank Wire. Please <a href="{FSROOT_URL}upload-documents">upload your documents</a></p>',
  bankwire_amount_label: 'Amount ({minDeposit} min. deposit)',
  bank_name: 'bank name',
  full_name: 'full name',
  deposit_methods: 'deposit methods',
  deposit_select_ta_p: 'Please select the trading account you wish to deposit funds to:',
  coming_soon: 'coming soon',
  amount: 'amount',
  proof_of_id: 'Proof of ID',
  proof_of_id_instructions: 'Proof of ID',
  documents_must_contain_all_of_the_following_details: 'Documents must meet the following requirements:',
  your_full_name: 'Your full name',
  a_unique_id_number: 'A unique ID number',
  your_birthdate: 'Your birthdate',
  your_place_of_birth: 'Your place of birth',
  a_visible_photo: 'A visible photo',
  your_signature: 'Your signature',
  your_nationality: 'Your nationality',
  proof_of_residence_instructions: 'Please upload your utility bill or bank statement.',
  your_residential_address: 'Your residential address',
  date_of_issue: 'Date of issue',
  other: 'other',
  other_documents_instructions: 'Other documents which have been requested by our verification department.',
  deposit_failed: 'deposit failed',
  deposit_successful: 'deposit successful',
  already_logged_in: 'already logged in',
  login: 'log in',
  create_an_account: 'create an account',
  partner_clients: 'Partner - Clients',
  trades: 'trades',
  client_id: 'Client ID',
  trading_account: 'trading account',
  metatrader_web_client: 'metatrader web client',
  platform: 'platform',
  order: 'order',
  pair: 'pair',
  volume: 'volume',
  close_date: 'close date',
  commission: 'commission',
  status: 'status',
  total_commission_generated: 'total commission generated',
  total_deposits: 'total deposits',
  total_withdrawals: 'total withdrawals',
  date_joined: 'date joined',
  more: 'more',
  banners: 'banners',
  partner_marketing_material: 'Partner - Marketing material',
  partner_overview: 'Partner - Overview',
  partner_payout: 'Partner - Payout',
  partner_payout_request_message: 'Your request have been recorded.',
  select_your_default_payment_option: 'Select your default payment option:',
  beneficiary_name_on_account: 'Beneficiary (Name on account)',
  bank_address: 'Bank Address',
  sort_code: 'Sort code (for UK Clients)',
  your_provider_email: 'Your {provider} email',
  select: 'select',
  next: 'next',
  please_confirm_your_bank_details: 'Please confirm your bank details:',
  bank: 'bank',
  sub_partners: 'Sub Partners',
  state: 'state',
  date: 'date',
  internal_transfer_instructions:
    'You can transfer funds between your trading accounts.<br>Please enter the desired transfer amount and select the source and destination accounts.<br>Internal transfers are processed immediately.',
  transfer_complete: 'transfer complete',
  transfer_from: 'transfer from',
  internal_transfer_processed_successfully: 'Internal transfer was processed successfully.',
  external_transfer_processed_successfully: 'External transfer was processed successfully.',
  select_account: 'select account',
  to: 'to',
  warning_currency_conversion_will_take_place: 'warning: currency conversion will take place',
  transfer: 'transfer',
  account: 'account',
  currency: 'currency',
  balance: 'balance ',
  equity: 'equity',
  download: 'download',
  launch: 'launch',
  email: 'email',
  password: 'password',
  forgot: 'forgot',
  forgot_password: 'forgot password',
  risk_warning_footer:
    'Risk warning: Trading leveraged products such as Forex and CFDs may not be suitable for all investors as they carry a degree of risk to your capital. Please ensure that you fully understand the risks involved, taking into account your investments objectives and level of experience, before trading, and if necessary seek independent advice. Please read the full <a href="{riskURL}">Risk Disclosure</a>.',
  error_contact_support: 'Something went wrong, please contact support.',
  type: 'type',
  funded: 'funded',
  username: 'username',
  company_name: 'company name',
  website: 'website',
  first_name: 'first name',
  last_name: 'last name',
  date_of_birth: 'date of birth',
  gender: 'gender',
  phone: 'phone',
  dial_code: 'dial code',
  country: 'country',
  address: 'address',
  year_moved_to_address: 'year moved to address',
  post_code: 'post code',
  selected_currency: 'selected currency',
  january: 'january',
  february: 'february',
  march: 'march',
  april: 'april',
  may: 'may',
  june: 'june',
  july: 'july',
  august: 'august',
  september: 'september',
  october: 'october',
  november: 'november',
  december: 'december',
  already_have_an_account: 'already have an account',
  invalid_request_login_required: 'invalid request, you need to login first.',
  register_accounttype_account: 'register {accountType} account',
  client_type: 'client type',
  individual: 'individual',
  company: 'company',
  company_information: 'company information',
  company_website: 'company website',
  complete_live_registration: 'complete live registration',
  title: 'title',
  confirm_password: 'confirm password',
  select_country: 'select country',
  phone_number: 'phone number',
  choose_trading_platform: 'choose trading platform',
  select_option: 'select option',
  day: 'day',
  month: 'month',
  year: 'year',
  company_registration_information: 'company registration information',
  date_of_registration: 'date of registration',
  select_nationality: 'select nationality',
  nationality: 'nationality',
  select_gender: 'select gender',
  male: 'male',
  female: 'female',
  address_line: 'address line',
  city_town: 'city/town',
  state_province: 'state/province',
  select_year: 'select year',
  year_moved_to_current_address: 'year moved to current address',
  company_shareholders_directors: 'company shareholders & directors',
  number_of_shareholders: 'number of shareholders',
  number_of_directors: 'number of directors',
  shareholder: 'shareholder',
  financial_information: 'financial information',
  total_estimated_net_worth: 'total estimated net worth (€)?',
  less_than_amount: 'less than {amount}',
  over_amount: 'over {amount}',
  total_estimated_annual_income: 'total estimated annual income (€)?',
  employment_information: 'employment information',
  employment_status: 'employment status',
  employed: 'employed',
  self_employed: 'self employed',
  retired: 'retired',
  student: 'student',
  unemployed: 'unemployed',
  source_of_income: 'source of income',
  employment: 'employment',
  inheritance: 'inheritance',
  investment: 'investment',
  trading_experience: 'trading experience',
  forex_cfds_and_other_instruments: 'forex, cfds and other instruments',
  yes: 'yes',
  no: 'no',
  lose_capital_risk:
    'Derivative products are suitable as part of my investment objectives and attitude towards risk and i am able to assess the risk involved in trading them, including the possibility that i may lose all of my capital',
  prev_pro_qualifications: 'I have previous professional qualifications and/or work experience in the financial services industry',
  account_type: 'account type',
  choose_currency: 'choose currency',
  tos_with_link: 'I have read, understood and accepted the terms and conditions and risk warning disclosure <a target="_blank" href="{URL}">here</a>',
  registration_successful: 'registration successful',
  reset_password_invalid_link: 'Your reset link is invalid, please try again or contact support.',
  reset_account_password: 'reset account password',
  choose_your_new_password: 'choose your new password',
  reset_password: 'reset password',
  file_upload_failed_filename: 'requested upload for file {filepath} failed.',
  withdrawal_request_success_message: 'your withdrawal request has been successful',
  withdraw: 'withdrawal',
  please_fill_the_following: 'please fill the following',
  cancel: 'cancel',
  withdraw_select_ta_p: 'Please select the trading account you wish to withdraw from:',
  free_margin_change_warning: 'Please note that the withdrawal should be made with the same method in which you deposited to your account.',
  you_need_an_ib_account_to_visit_this_page: 'You need an IB account to visit this page',
  no_permission_to_to_visit_this_page: "You don't have permission to to visit this page",
  you_became_a_partner_successfully: 'You became an EUROTRADER partner successfully!',
  note_wallet_currency_conversion_partner:
    "Please note that by becoming a Partner, your wallet's currency will be changed to USD and that any current funds will be converted to USD with the current exhchange rate!",
  upgraded_to_a_live_account_successfully: 'Upgraded to a live account successfully!',
  passwords_dont_match: "Passwords don't match",
  password_rules: 'At least 1 capital, 1 lowercase and 1 number (6 to 16 max characters)',
  please_fill: 'please fill',
  partner_verify_first_notice: 'To become a partner you need to verify your account first. Please upload your documents <a href="upload-documents">here</a>',
  only_currency_format_allowed: 'only currency format allowed',
  please_enter_your_account_id: 'Please enter your account ID',
  min_deposit_with_bankwire_is_amount: 'Min. deposit with bankwire is {amount}',
  please_select_different_tas: 'Please select different trading accounts',
  you_need_to_accept_our_tos: 'You need to accept our Terms and Conditions.',
  phone_is_required: 'phone is required',
  invalid_phone_number: 'invalid phone number',
  you_must_be_over_18: 'You must be over 18.',
  year_is_required: 'Year is required',
  leave_page_question: 'Leave page?',
  registration_exit_notice: "You haven't finished your registration yet. You want to leave without finishing?",
  internal_server_error_support: 'Internal server error. Please contact support',
  please_fill_all_fields: 'Please fill all fields',
  no_logs_found_for_this_client: 'No logs found for this client',
  no_accounts_send: 'No accounts send',
  internal_server_error_try_again: 'Internal server error. Please try again later',
  insufficient_balance: 'Insufficient balance',
  currency_conversion_connection_error: 'No response from currency conversion server, please try again or contact support.',
  currency_conversion_error: 'Currency conversion error, please try again or contact support.',
  invalid_accounts: 'Invalid accounts',
  withdrawal_unsuccessful_equity_message: 'Withdrawal unsuccessful, not enough equity on trading account {TAID}',
  withdrawal_failed_free_margin: 'Withdrawal failed. Please double check your free margin.',
  pamm_copy_server_field_message: 'please copy and paste the IP address in to the "Server" field in your MT4 server',
  invalid_request: 'invalid request',
  missing_shareholders_directors: 'Missing shareholders/directors',
  missing: 'Missing',
  invalid_request_passwords_do_not_match: 'Invalid request. Passwords do not match',
  email_exists_message: 'Email exists, please try with another email address.',
  your_payment_method_has_already_been_set: 'Your payment method has already been set. Please contact support',
  payment_method_is_required_message: 'Payment method is required. Please try again or contact support',
  couldnt_find_your_account: "Couldn't find your account",
  ta_limit_error_message: 'Your account has reached the trading accounts limit({limit}) for {platform}.',
  error: 'error',
  account_created_successfully: 'account created successfully',
  invalid_leverage: 'invalid leverage',
  insufficient_data_provided: 'insufficient data provided',
  insufficient_data_provided_missing_field: 'Insufficient data provided. Missing {field}.',
  invalid_amount: 'invalid amount',
  account_taid_doesnt_exist: "Account {TAID} doesn't exist",
  withdrawal_unsuccessful_equity_taid: 'Withdrawal unsuccessful, not enough equity on trading account {TAID}',
  withdrawal_unsuccessful_free_margin_taid: 'Withdrawal unsuccessful, not enough free margin on trading account {TAID}',
  internal_server_error: 'internal server error',
  deposit_failed_support: 'Deposit was unsuccessful, please contact support.',
  upload_documents_instructions: 'Please provide us with the following documents.<br>Files should be in PDF, JPG or PNG format and must not exceed 5mb.',
  total_earned: 'total earned',
  total_paid: 'total paid',
  total_clients: 'total clients',
  total_sub_ibs: 'total sub ibs',
  see_trading_accounts: 'see trading accounts',
  see_trades: 'see trades',
  welcome_title_live: 'Thank you for opening your account with EUROTRADER!',
  welcome_title_demo: 'Thank you for opening your demo account with EUROTRADER!',
  welcome_title_ib: 'Thank you for opening your Partners account with EUROTRADER!',
  welcome_text_live:
    '<p>To get funded, approved and ready to trade, you need to complete the following steps:</p><ul><li>Log in to your Eurotrader Client Portal</li><li>Upload your documents</li><li>Fund your account</li><li>Start trading!</li></ul><p>If you need any help, our friendly customer support team is available 24/5. To contact them, click <a href="{contactURL}" target="_blank">here</a></p>',
  welcome_text_demo:
    '<p>To get funded, approved and ready to trade, you need to complete the following steps:</p><ul><li>Download the MT4 platform</li><li>Test your trading skills and our execution speeds</li><li>Log in to your Client Portal and upgrade to a live account</li><li>Upload your documents and fund your account</li><li>Trade the largest financial market in the world!</li></ul><p>If you need any help, our friendly customer support team is available 24/5. To contact them, click <a href="{contactURL}" target="_blank">here</a></p>',
  welcome_text_ib:
    '<p>In order to have your Partners account approved and ready for you to receive your referral URL, you need to complete the following steps:</p><ul><li>Log in to your Client Portal</li><li>Upload your documents</li><li>Receive your tracking URL in the "overview" and "marketing tools" section</li><li>Refer your clients and receive commission!</li></ul><p>If you need any help, our friendly customer support team is available 24/5. To contact them, click <a href="{contactURL}" target="_blank">here</a></p>',
  bankwire_passports_notice: 'IMPORTANT: Passports as proof of ID are required in order to make a wire transfer.',
  tracking_links: 'tracking links',
  proof_of_residence: 'proof of residence',
  login_to_your_account: 'login to<br>your account',
  register: 'register',
  open_demo_account: 'open demo account',
  create_partner_account: 'create partner account',
  page_title_partner: 'Become a partner | Eurotrader',
  ib_payout_msg_monthly_payment: 'Payouts are made bi-monthly via the method of your choice. Payouts will be made on the 15th and 1st business day of each month.',
  payout_selection_complete: 'Payment method has been selected.',
  home: 'home',
  about: 'about',
  account_types: 'account types',
  spreads: 'spreads',
  funding: 'funding',
  education: 'education',
  contact: 'contact',
  forex_broker: 'forex broker',
  services_provided_by: 'Financial services provided by Eurotrade Global Ltd',
  footer_certificate_eurotrader:
    'Eurotrade SA (Pty) Ltd (“Eurotrader”) is a subsidiary of Eurotrade RGB Holdings Ltd (HE367109) and is an authorized financial services provider, licensed and regulated by the Financial Sector Conduct Authority (FSCA) in South Africa with license number FSP <a href="https://www.fsca.co.za/Fais/Search_FSP.htm" style="color: #e04ef8; text-decoration: underline" target="_blank">44351</a> with registered address at 74 Walmer street, Sydenham, Johannesburg, 2192, South Africa.<br /><br /><!-- ‘Eurotrader’ is a registered brand of Eurotrade Investments RGB Ltd, a Cypriot Investment Firm (CIF) under the Registration Number HE317893, licensed and regulated by the Cyprus Securities and Exchange Commission (CySEC) under license 279/15 with registered address at 70, Kyrillou Loukareos Street, Kakos Premier Tower, 1st Floor, 4156 Limassol, Cyprus. Card processing will be completed by Eurotrade Investments RGB Ltd.<br /><br /> -->Eurotrader does not provide services to residents of certain jurisdictions including the USA, Iran, Canada, the Democratic Republic of Korea, Belgium, Japan, and is not intended for distribution to, or use by, any person in any country or jurisdiction where such distribution or use would be contrary to local law or regulation.<br /><br />Eurotrade SA (PTY) Ltd does not actively target EU clients.',
  footer_risk_warning:
    'Trading leveraged products such as Forex and CFDs may not be suitable for all investors as they carry a degree of risk to your capital. Please ensure that you fully understand the risks involved, taking into account your investments objectives and level of experience, before trading, and if necessary seek independent advice. <a href="https://eurotrader-com.s3.eu-west-2.amazonaws.com/legal-documents/Risk%20Disclosure.pdf" style="color: #e04ef8; text-decoration: underline" target="_blank">Please read the full Risk Disclosure.</a>',
  open_live_account: 'open live account',
  not_registered_with_question: 'Not registered with eurotrader?',
  forgot_password_q: 'forgot your password?',
  pending_deposit_success: 'Operation successful, your deposit is now pending approval',
  your_card_will_be_charged_cny: 'Your card will be charged <b>{amount}</b> CNY',
  currency_conversion_info: 'Currency conversion info',
  min_deposit_is_amount: 'Min. deposit is {amount}',
  min_transfer_is_amount: 'Min. transfer is {amount}',
  local_depositor: 'Local depositor',
  converted_amount: 'converted amount',
  from_currency: 'from currency',
  to_currency: 'to currency',
  reference_id: 'reference id',
  from_account: 'from account',
  to_account: 'to account',
  from_date: 'from date',
  to_date: 'to date',
  target_account_id: 'target account id',
  wallet: 'wallet',
  received: 'received',
  send: 'send',
  sender_not_a_transfer_account: 'sender is not a local depositor',
  withdrawal_failed_support: 'Withdrawal was unsuccessful, please contact support.',
  clear: 'clear',
  transfer_completed_successfully: 'transfer completed successfully',
  receive: 'receive',
  view_trades: 'view trades',
  your_provider_account_number: 'Your {provider} account number',
  your_bitcoin_address: 'Your bitcoin address',
  your_crypto_address: 'Your {crypto} address',
  destination_tag: 'Destination tag',
  change_trading_account_password: 'change trading account password',
  your_card_will_be_charged_thb: 'Your card will be charged <b>{amount}</b> THB',
  dashboard: 'dashboard',
  sent: 'sent',
  client_state_approved: 'approved',
  client_state_pending: 'pending',
  client_state_incomplete: 'incomplete',
  open_trades: 'open trades',
  trade_history: 'trade history',
  search_trades: 'search trades',
  trade_no: 'trade no',
  symbol: 'symbol',
  open_price: 'open price',
  close_price: 'close price',
  datetime: 'datetime',
  my_bonuses: 'my bonuses',
  bonus: 'bonus',
  conversion_progress: 'conversion progress',
  front_of_id: 'Front of ID',
  back_of_id: 'Back of ID',
  include_account_in_bonus_program: 'I would like to join the 111% Funded Trading Program.',
  invest_under_master_account: 'invest under master account',
  i_accept_the_terms_of_service: 'i accept the Terms of Service',
  pamm_master_locks_withdrawals: '[this pamm master restricts withdrawals during open trades!]',
  open_p_l: 'open p&l',
  p_l: 'P&L',
  gains_prc: 'gains %',
  max_drawdown: 'max. drawdown',
  bonus_tos_with_link: 'I have read and understood the <a target="_blank" href="{URL}">terms and conditions of the 111% Funded Trading Program</a>.',
  i_am_over_18: 'I declare that I am over 18 (eighteen) years old to open this Account.',
  all_time: 'all time',
  last_month: 'last month',
  last_week: 'last week',
  last_3_days: 'last 3 days',
  monthly_avg: 'monthly avg',
  profit: 'profit',
  create_and_attach: 'create and attach',
  attach: 'attach',
  create_and_attach_new_pamm_account: 'create and attach new pamm account',
  select_a_pamm_account_to_attach: 'select a pamm account to attach',
  enter_private_code: 'enter private code',
  private_code: 'private code',
  investor_link: 'Investor Link',
  i_accept_the_lpoa: 'i accept the lpoa',
  invest: 'invest',
  view_graph: 'view graph',
  name: 'name',
  search: 'search',
  partners: 'partners',
  reject_withdrawls_during_open_trades: 'reject withdrawals during open trades',
  private_master_account: 'private master account',
  minimum_deposit: 'minimum deposit',
  performance_fee: 'performance fee',
  display_name: 'display name',
  new_master_account: 'new master account',
  pamm_statistics: 'pamm statistics',
  pamm: 'pamm',
  volume_traded: 'volume traded',
  apply_date_range: 'apply date range',
  pamm_master_locks_deposits: '[this pamm master restricts deposits during open trades!]',

  // new with vue
  bitcoin: 'Bitcoin',
  register_live_account: 'register live account',
  register_partner_account: 'register partner account',
  register_demo_account: 'register demo account',
  risk_disclosure: 'risk disclosure',
  address_line_2: 'address line 2',
  skype_id: 'skype id',
  password_rules_extended:
    'The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character. Password length must be between 8 to 16 characters.',
  login_information: 'login information',
  director: 'director',
  pmethod_visa_mastercard: 'VISA/MASTERCARD',
  pmethod_visa_mastercard_alternative: 'VISA/MASTERCARD.',
  pmethod_bitcoin: 'BITCOIN',
  pmethod_bankwire: 'Bankwire',
  pmethod_fasapay: 'Fasapay',
  pmethod_ideal: 'ideal',
  pmethod_instant_bank_transfer: 'Instant Bank Transfer',
  pmethod_jeton: 'Jeton',
  pmethod_jeton_wallet: 'Jeton Wallet',
  pmethod_my_pay: 'MyPay',
  pmethod_neteller: 'NETELLER',
  pmethod_vload: 'VLOAD',
  pmethod_paykasa: 'Paykasa',
  pmethod_skrill: 'Skrill',
  pmethod_sofort: 'Sofort',
  pmethod_koalapay: 'KoalaPay',
  pmethod_cup: 'CUP',
  pmethod_lydiax: 'Crypto',
  pmethod_safecharge: 'SafeCharge',
  pmethod_trustly: 'Trustly - Bank Wire',
  pmethod_powercash: 'PowerCash',
  pmethod_astropay: 'AstroPay',
  pmethod_payneteasy: 'Payneteasy',
  pmethod_card_mulix: 'Mulix (TEST)',
  pmethod_mulix_card: 'Card payment',
  pmethod_mulix_payretailers: 'PayRetailers',
  pmethod_mulix_crypto: 'Crypto',
  pmethod_pix: 'PIX',
  field_min_currency_value: 'The {field} field must be {min} or more.',
  method_deposit: '{method} deposit',
  method_deposit_status: '{method} deposit status',
  quick_menu: 'quick menu',
  details: 'details',
  date_from: 'date from',
  date_to: 'date to',
  from: 'from',
  forgot_password_form_instruction: "Please submit your account's email address below. You will then receive an email with a link for resetting your password.",
  forgot_password_submit_success_message: 'A password reset link has been sent to your email. Please go to your email ({email}) and follow the link to change your password.',
  password_reset_successfully: 'Your password has been successfully reset',
  password_too_week_or_mismatch: 'Password too weak or passwords entries mismatch.',
  withdrawals_credit_card_remaining_amount_message: 'In order to withdraw via other methods, you must first withdraw {amount} back to your credit card.',
  withdrawals_credit_card_refund_policy_message: 'Credit Card providers only allow you to withdraw the total amount you deposited back to your card.',
  withdrawals_amount_withdrawable_message: 'A total of {amount} can be withdrawn back to your card, anything over that amount can be withdrawn by one of our other methods.',
  country_blocked_for_this_method: 'Your country is blocked for this method',
  copied_text_successfully: 'copied {text} successfully',
  choose_wallet_currency: 'choose wallet currency',
  pamm_master_account_created_successfully: 'PAMM master account created successfully!',
  or_account_no_for_uk: 'or Account Number (for UK Clients)',
  issue_date: 'Issue date',
  expiry_date: 'Expiry date',
  full_copy_of_the_document: 'Full copy of the document showing all 4 corners',
  recent_date: 'Recent date (not older than 3 months)',
  your_physical_address: 'Your physical address, matching the address you have used when registering for the account',
  must_be_a_utility_bill: 'Must be a Utility Bill (electricity, water, telephone, gas /energy, council tax/sanitation bills) or a Bank statement',
  for_further_info_attach: '**For further documentation, please attach them on an email and send to backoffice@eurotrader.com',
  banners_ad_blocker_notice: 'If you have trouble viewing the banners below, please disable your ad-blocker',
  content_ad_blocker_notice: 'If you have trouble viewing the web client, please disable your ad-blocker',
  transfer_out: 'transfer out',
  transfer_in: 'transfer in',
  done: 'done',
  not_required: 'not required',
  wallet_balance: 'wallet balance:',
  must_agree_terms: 'You must agree to our Terms and Conditions to create an account',
  select_payment_method: 'select payment method',
  islamic_account: 'Islamic account',
  islamic_documents_instructions: 'Proof of faith/religion from the mosque',
  card_number: 'card number',
  expiry: 'Expiry',
  redeem: 'redeem',
  must_be_multiple_of_10: 'Value must be a multiple of 10',
  select_starting_balance: 'Select starting balance',
  business_name: 'business name',
  business_bank_wire_instructions: 'business bank wire instructions',

  error_request_failed: 'Error: Request failed',
  error_no_user_with_this_email: 'Error: An account with this email address was not found',
  error_too_many_password_reset_requests: 'Error: Too many password resets requested',
  error_expired_or_invalid_request: 'Error: Invalid or expired request',
  error_insufficient_wallet_balance: 'Error: Insufficient balance in wallet',
  error_insufficient_balance_or_equity: 'Error: Insufficient balance or equity',
  error_pamm_master_deposit: 'Cannot deposit in a PAMM master account',
  error_pamm_master_withdrawal: 'Cannot withdraw from a PAMM master account',
  error_pamm_master_locked_deposits: 'Rejected: The pamm master of the account to which money is deposited rejects deposits during open trades.',
  error_pamm_master_locked_withdrawals: 'Rejected: The pamm master of the account from which money is withdrawn rejects withdrawals during open trades.',
  error_pamm_master_minimum_deposit: "Rejected: The pamm master's minimum deposit requirement was not met.",
  error_live_account_already: 'Your account is a live account already',
  error_min_balance_required_is: 'The minimum balance required for the {TAAccountType} account({TAID}) is {min}{currency}.',
  error_transfer_same_wallet: 'Cannot transfer from wallet to wallet.',
  error_transfer_same_trading_account: 'Cannot transfer from and to the same trading account.',
  error_no_deposit_bonus_account_deposit_restricted: 'Deposits to "No Deposit Bonus" type of account is not allowed.',
  error_no_deposit_bonus_base_amount_withdrawal: 'Cannot withdraw base amount of "No Deposit Bonus".',
  error_no_deposit_bonus_withdraw_profit_requirement_not_met: 'Cannot withdraw "No Deposit Bonus" if profit requirement has not been met.',
  error_no_deposit_bonus_withdraw_exceeds_max_withdrawable_profit: 'Cannot withdraw more than the max withdrawable profit.',
  upgrade_required_for_live_ta: 'Live and Approved client account is required before a live trading account can be opened!',
  error_wallet_currency_not_allowed_for_psp: 'Wallet currency not allowed for this payment method.',
  error_invalid_or_expired_otp: 'Error: Provided OTP is invalid or expired.',
  error_max_confirmo_withdrawal_exceeded: 'Error: Maximum confirmo withdrawal request is 20000 EUR/USD',
  error_max_anual_vload_withdrawal_exceeded: 'Error: Maximum anual vload withdrawal requests total amount exceeded',

  // Check for islamic trading account (temporarily disabled)
  is_islamic_acc_message: 'In order to create an Islamic account, please send a request to backoffice@eurotrader.com as to assist you further.',
  error_invalid_voucher: 'Error: VLoad voucher invalid or already redeemed',
  error_blocked_voucher: 'Error: VLoad Voucher is blocked due to fraud suspicion',
  error_voucher_data_mismatch: 'Error: VLoad Voucher was declined due to mismatch of account data.',
  error_vload_voucher_below_minimum: 'Error: Vload voucher below minimum deposit amount.',
  my_bank_has_a_swift_code: 'My bank has a swift code',
  my_bank_does_not_have_a_swift_code: 'My bank does not have a swift code',
  bank_not_in_swift_network_instructions:
    'If your bank is not a SWIFT network member, please provide us with the following details of your bank’s Correspondent bank in order to receive International wires:',
  correspondent_bank_name: "Correspondent Bank's Name",
  correspondent_bank_city: "Correspondent Bank's City",
  correspondent_bank_swift: "Correspondent Bank's Swift",
  swift: 'SWIFT',
  iban: 'IBAN',
  codigo: 'Codigo de Instituicao',
  personalId: 'CPF',
  identity_card: 'Identity Card',
  DNI_personalID: 'DNI',
  CURP_personalID: 'CURP',

  // New document upload strings
  proof_of_cc: 'Proof of Credit/Debit Card',
  front_of_cc: 'Front of card',
  back_of_cc: 'Back of card',
  proof_of_cc_instructions: 'Please upload your credit or debit card.',
  add_document: 'Add a document (Optional)',
  cc_requirements_1: 'Full copy of the document showing all 4 corners.',
  cc_requirements_2:
    'Card name: the card you will be using must be issued in your name solely. Any deposits made using a card belonging to a third party, will be immediately refunded.',
  cc_requirements_3: 'Expiry Date: no less than 3 months.',
  cc_requirements_4: 'Card number: The middle eight numbers of the card must be covered with a piece of paper. Only the first four and last four digits should be visible.',
  cc_back_requirements_5: 'CVV code: Please use a piece of paper to cover the CVV code.',
  cc_back_requirements_6: 'The card must be signed.',
  click_to_add_another_document: 'Click above to add another document upload slot',
  add_up_to_4_extra_documents: 'You can add up to 4 additional documents',
  add_up_to_10_extra_documents: 'You can add up to 10 additional documents',
  complete_profile: 'Complete Profile',
  document_received: 'Your document was received and will be reviewed by our team.',
  please_check_the_box: 'Please check the box below.',
  must_be_over_18: 'You must be over 18 years of age to register.',
  shareholders_must_be_over_18: 'Shareholders must be over 18 years of age to register.',
  directors_must_be_over_18: 'Directors must be over 18 years of age to register.',
  document_req_color: 'Document must be in color',
  internal_error: 'An internal error occured..',
  please_enter_your_email: 'Please enter your email address.',
  do_you_want_to_transform_your_trading: 'Do you want to transform your trading?',
  reset_your_password_to_transfer_your_account: 'Reset your password to transfer your account.',
  reset_your_old_password: 'Reset your old password',
  reset_password_desc: 'Due to a system transfer, your are required to update your password. Please use the form below to receive a reset password link.',
  eurotrader_login: 'Eurotrader Login | Enter the trading hub to level up your trading',
  your_email_is_verified: 'Your email is already verified.',
  click_here_to_login: 'Click here to login',
  success_email_verified: 'Success, Your email is now verified!',
  your_link_expired: 'Your link has expired',
  click_here_to_request_verification_email: 'Click here to request a new verification email.',
  a_new_verification_link_send: 'A new verification link has been sent to your email address.',
  invalid_request_please_check_your_link: 'Invalid request. Please check your link is correct and try again.',
  invalid_verification_code: 'Invalid verification code',
  please_enter_amount: 'Please enter the amount you wish to deposit',
  bankwire_company_desc:
    '<p>If you are a business bank account holder and you want to use the option of bank wire transfer by registering your business account with us, please send us the following documentation via e-mail to backoffice@eurotrader.com</p><ul><li>Certificate of Incorporation/Company</li><li>Certificate of Directors and Secretary, if applicable</li><li>Certificate of Registered Shareholders/ Sole Owner.</li><li>Memorandum and Articles of Association, also known as Articles</li><li>Proof of Identification and Address for all registered Shareholder/s, Beneficial Owner/s and Director/s.</li><li>Proof of address relating to the company.</li></ul><p>Any other government/official documents verifying the above requested information can be considered sufficient, in case the above documents cannot be provided in such format.</p>',
  bankwire_noncompany_desc:
    '<p>This will log you out from your personal account and redirect you to our registration page for a Company account.</p><p>Would you like to proceed?</p>',
  please_enter_card_detail_and_amount: 'PLEASE ENTER CARD DETAILS AND AMOUNT YOU WISH TO DEPOSIT',
  important: 'IMPORTANT',
  please_note_that_the_maximum_deposit_amount: 'Please note that the maximum deposit amount per day is $1000 per card.',
  city: 'City',
  zip: 'Zip',
  please_note_that_after_three_unsuccessful_attempts:
    '* Please note that after three (3) unsuccessful attempts the VISA/MASTERCARD payment option will be unavailable for 24hours.',
  epay_pro_desc:
    '<p>Dear Trader<br><br>Unfortunately, due to certain technical issues and restrictions, Credit Card Deposits will be temporarily disabled via our provider EPayPro.<br><br>Visa & Mastercard will be disabled at midnight 23:00 GMT 04/04/2018. Following the payment provtider being disabled, deposits will be temporarily disabled. Although our payment providers have not provided us with an exact time frame for the downtime, we are working on implementing alternatives as soon as possible.<br><br>We are working with our providers to resolve the current issues so that in future, the accounts can resume processing deposits without delay.<br><br>Feel free to contact our support team should have any further questions.</p>',
  provider_redirect: 'You will be redirected to {provider}.',
  lydiax_note: 'The minimum deposit is 30 EUR/USD',
  lydiax_note1:
    'If you deposit less than 30 EUR/USD worth of {crypto}, you will need to send an email to backoffice@eurotrader.com, and request a refund, providing the {crypto} address you wish to be refunded to.',
  lydiax_note2:
    'Please enter the {crypto} amount you wish to deposit to see an estimation of what you will get. Keep in mind that the following prices are only valid for when they were requested and can change any moment.',
  lydiax_note3: 'We will create a deposit address for you to use.',
  lydiax_note4: 'Please use the following address to deposit {crypto}.',
  lydiax_note5: 'Hereafter, this unique address will be used for your deposits in {crypto}.',
  lydiax_required_address: 'If your wallet requires address and tag separately use:',
  tag: 'Tag',
  lydiax_enter_deposit: 'PLEASE ENTER THE CRYPTOCURRENCY YOU WISH TO DEPOSIT',
  create_address: 'Create address',
  please_note: 'Please note:',
  price_estimate: 'Price estimate:',
  check_price: 'Check price',
  vload_please_enter_voucher: 'PLEASE ENTER YOUR VLOAD VOUCHER PIN NUMBER',
  vload_minimum: '<p>(Minimum acceptable voucher value is<b>50</b> EUR or USD!)</p>',
  vload_vouchers: 'I need to purchase VLoad Vouchers',
  vload_note: 'Make a hassle-free payment by Visa/MasterCard as well as Bank Wire Transfer.<br />Learn more about VLoad or buy a [EUR / USD] voucher at vload.expert.',
  vload_note1: 'In order to be able to deposit with VLoad, your account must first be approved!',
  reason: 'Reason:',
  attempts: 'Attempt {attempts} of {maxAttempts},',
  two_more_remaining: 'two (2) more remaining',
  one_more_remaining: 'Only ONE (1) attempt remaining',
  please_contact_bank: '<br />Please contact the card-issuing bank.<br /> Your card may be blocked for overseas transactions',
  edata_success_note:
    'Please note that there may be an additional fee on your deposit, charged by your issuing bank due to the international transaction. This fee will be small charge, but it will vary from bank to bank. <br><br>This credit card transaction will appear on your statement as“ Tech Savvy Billing ", “Business Billing “ or “Business media Billing “.',
  you_can_try: 'you can try again',
  here: 'here',
  safe_charged_success_message: 'Your deposit will be processed by our backoffice within 2 working days.',
  thank_you: 'Thank you!',
  your_deposit_successful: 'Your deposit was successful',
  card_redirect: 'You will be redirected to enter your credit card and personal details.',
  bank_wire_withdrawal_note:
    'In case of rejection of a Bank Wire Transfer on behalf of the receiving bank due to wrong bank details provided by the client, the various bank wire administration expenses charged by the banks involved will be subtracted from the requested withdrawal amount prior to crediting the client’s wallet.',
  please_enter_amount_withdraw: 'Please enter the amount you wish to withdraw',
  bitcoin_note: 'Please enter your bitcoin address and the amount you wish to withdraw',
  otp: 'One-time Password (OTP)',
  otp_send_email: 'Send OTP to Email',
  otp_additional_text: 'The above OTP is for the current Bitcoin withdrawal request you are making',
  otp_new_password: 'A new one-time password (OTP) has been sent to your email',
  otp_error: 'Error - Failed to send OTP',
  lydiax_withdrawal_note:
    'Please enter the {currency} amount you wish to withdraw to see an estimation of {crypto} that you will get. Keep in mind that the following prices are only valid for when they were requested and can change any moment.',
  enter_currency_amount: 'Enter {currency} amount to check estimate',
  lydiax_withdrawal_additional_note: 'The above OTP is for the current Crypto withdrawal request you are making',
  estimated: 'Estimated:',
  please_enter_your_crypto_address: 'Please enter your {crypto} address and the amount you wish to withdraw',
  select_cryptocurrency: 'Select cryptocurrency',
  request_amount: 'Requested Amount',
  amount_changes: 'Amount Charged (includes fee)',
  operation_failed: 'Operation failed! Your request was invalid.',
  operation_failed_error: 'Operation failed! There was an error processing this request.',
  are_you_sure_create_master: 'Are you sure you wish to create a new account and attach it under this master?',
  are_you_sure_attach_selected_account_to_master: 'Are you sure you wish to attach selected account to this master?',
  change_password_desc:
    '<strong>*</strong> This password change will not affect your trading account passwords. Please visit <strong>account list</strong> to change your trading account passwords, using the <strong>change password</strong> option under the gear icon.',
  client_assessment: 'CLIENT ASSESSMENT',
  select_answer: 'Select an answer...',
  declarations: 'DECLARATIONS',
  complele_profile_desc:
    'Are you currently, or have you ever been, involved in any criminal activity or are there any outstanding criminal charges against you pending before a court?',
  complete_profile_desc1:
    'Are you or a relative or close associate of yours a Politically Exposed Person? Politically Exposed Persons are the natural persons who are or have been entrusted with prominent public functions within the last 12 months, i.e Heads of State or of government, senior politicians, senior government, judicial or military officials, senior executives of state owned corporations, important political party officials.',
  are_you_us_citizen: 'Are you a U.S citizen or U.S. resident for tax purposes?',
  please_check_forms_errors: 'Please check the forms for errors!',
  profile_succesfully_completed: 'Profile successfully completed',
  please_select_country: 'Please select your Country',
  set_country: 'Set country',
  empty_country_code: 'Empty country code, please refresh the page and try again.',
  invalid_country_code: 'Invalid country code, please refresh the page and try again.',
  individual_company: 'ARE YOU AN INDIVIDUAL OR A COMPANY?',
  prev: 'PREV',
  previous: 'PREVIOUS',
  complete: 'COMPLETE',
  please_select_an_option: 'Please select an option for each field!',
  swap: 'swap',
  buy: 'buy',
  sell: 'sell',
  sums: 'sums',
  net_total: 'NET TOTAL',
  deposit_page_desc:
    '<p class = "has-text-white is-size-5-desktop is-size-6-tablet is-size-6-mobile has-text-weight-bold" >Sign up now and</p><p class = "is-size-1-desktop is-size-2-tablet is-size-3-mobile has-text-weight-bold vload-promo-large-text">Get a <span class = "has-text-white has-text-weight-bold"> FREE </span> <br/> 10 EUR/ USD<br/> eVoucher</p>',
  deposit_page_desc1: 'The 10 EUR/USD Bonus eVoucher will be activated once you',
  create_new_account: 'Create a new Account',
  successfully_purchase_vload: 'successfully purchase and redeem a VLoad eVoucher of any value',
  upgrade_to_tier_2: 'Upgrade to tier 2',
  register_now: 'REGISTER NOW',
  back: 'BACK',
  my_card_desc: 'Here you can see all the cards you`ve used for payments and their current status in our system.',
  you_have_no_card: 'You have made no card deposits yet.',
  card_no: 'Card No.',
  last_used: 'Last used',
  risk_warning: 'RISK WARNING',
  upload_documents_note: 'If you wish to make a Card deposit, please provide additionally the following documents as to be checked and approved.',
  please_select_your_country: 'Please select your country first',
  add_another_document: 'Add another document',
  drop_files_upload: 'Drop files here to upload',
  date_until: 'Date Until',
  copy: 'Copy',
  cvv: 'CVV',
  please_enter_crypto_amount: 'Enter {crypto} amount',
  vload_pin: 'VLoad Pin',
  deposit_info:
    'The payment provider is currently experiencing technical issues and direct Visa/Mastercard deposits are currently unavailable. Alternatively, if you would like to deposit using Visa/Mastercard you can use the `Vload` option',
  id: 'ID',
  pamm_modal_error: 'Invalid entry for Display Name. Please do not leave empty or enter more than 32 characters',
  pamm_modal_error1: 'Invalid value entered for Minimum Deposit. Please enter a positive whole number under 1,000,000.',
  error_missing_required_field: 'Error, missing required field',
  page_not_found: 'PAGE NOT FOUND',
  new_version_note: 'NEW VERSION DETECTED, PLEASE CLICK HERE TO REFRESH',
  new_version_note1: 'Some functions may be unavailable until you refresh the page',
  records: 'Records',
  gateway: 'gateway',
  account_no: 'Account No.',
  routing_no: 'Routing No.',
  agency_no: 'Agency No.',

  // Demo Account
  train_up: 'TRAIN UP.',
  trade_up: 'TRADE UP.',
  train_text_1: 'Ready to invest in your future self?',
  train_text_2: 'Get started with a risk-free demo account and access to Eurotrader Academy’s learning resources.',
  train_list_item_1: 'Practice trading in a simulated environment.',
  train_list_item_2: 'Gain access to best-in-class learning resources.',
  train_list_item_3: 'Become a part of the Eurotrader community.',
  train_list_item_4: 'Remember: nothing to lose, everything to gain.',
  form_title_1: 'GET PRACTICING WITH',
  form_title_2: 'YOUR',
  form_title_3: 'Demo Account',
  form_subtitle: 'And gain access to learning resources',
  region: 'Region',
  wallet_currency: 'Wallet Currency',
  select_currency_label: 'Currency of your demo account',
  join: 'join',
  demo_account: 'Demo Account',
  page_title_demo: 'Open demo account | Eurotrader',

  // 404 Page
  title_404: 'HEY MONEY, I AM HOME!',
  text_line_1_404: 'What? No one here to help you invest in your future self?',
  text_line_2_404: 'Let’s get back home and show your money what you’re made of.',
  button_404: 'GO BACK',

  remember_me: 'Remember me',
  risk_sentence: 'To see how we use your data, please review our',
  video_courses: 'Video Courses',
  ebooks: 'E-Books',

  // Complete Profile
  knowledge_and_experience: 'KNOWLEDGE AND EXPERIENCE',
  economic_profile: 'ECONOMIC PROFILE',
  product_governance: 'PRODUCT GOVERNANCE',
  select_an_answer: 'Select an answer',
  declarations_q1: 'Are you currently, or have you ever been, involved in any criminal activity or are there any outstanding criminal charges against you pending before a court?',
  declarations_q2:
    'Are you or a relative or close associate of yours a Politically Exposed Person? Politically Exposed Persons are the natural persons who are or have been entrusted with prominent public functions within the last 12 months, i.e Heads of State or of government, senior politicians, senior government, judicial or military officials, senior executives of state owned corporations, important political party officials.',
  declarations_q3: 'Are you a U.S citizen or U.S. resident for tax purposes?',

  ca_q1: '1. Do you have trading Experience?',
  ca_q2: '2. For how long have you invested/traded in the financial markets?',
  ca_q3: '3. How many transactions have you executed in the past two years? <br>&nbsp;&nbsp; a. Equities and Fixed Income (Shares & Bonds)',
  ca_q4: '&nbsp;&nbsp; b. Forex',
  ca_q5: '&nbsp;&nbsp; c. CFDs (Contracts for Differences)',
  ca_q6: '&nbsp;&nbsp; d. Other Derivatives Products (Warrants, Options, Rights)',
  ca_q7:
    '4. What were the average amounts (on a monthly basis) that you have invested to the following categories? <br> &nbsp;&nbsp; a. Equities and Fixed Income (Shares & Bonds)',
  ca_q8: '&nbsp;&nbsp; b. Forex',
  ca_q9: '&nbsp;&nbsp; c. CFDs (Contracts for Differences)',
  ca_q10: '&nbsp;&nbsp; d. Other Derivatives Products (Warrants, Options, Rights)',
  ca_q11: '5. What type of investment services have you already used? (contains multiple answers)',
  ca_q12: '6. Does any of the below apply to you? (contains multiple answers)',
  ca_q13:
    '7. Apple’s Share is trading at a sell price of $204 and a buy price of $206. You buy 100 shares of Apple at the aforementioned price. What would be the profit/loss incurred to your account if the price of Apple’s share was to move at a sell price of $190 and a buy price of $192 and you were to close your position?',
  ca_q14:
    '8. Apple Share is trading at a sell price of $204 and a buy price of $206. You open a long (buy) CFD trade for 100 contracts (each contract underlines 1 share of Apple). The leverage used is 1:5. What would be the profit/loss incurred to your account if the price of Apple’s share was to move at a sell price of $190 and a buy price of $192 and you were to close your position?',
  ca_q15: '9. Using a stop loss order:',
  ca_q16: '10. Your account balance is low. On which of these occasions might you be required to add funds to your account?',
  ca_q17:
    '11. The S&P 500 Index has a buy price of $2700. You decide to open a long (buy) CFD trade of 2 contracts. The leverage used is 1:20. You set a stop loss at the price of $2600 and a take profit at the price of $3000. Assuming the balance on your account is sufficient and the order is unchanged until either the stop loss sell price or the take profit sell price is attained and no additional charges are incurred, what would be the profit or loss that you would incur on your account when the position is closed?',
  ca_q18: '1. What is your total annual income?',
  ca_q19: '2. What is the source of your income?',
  ca_q20: '3. What percentage of your annual income relates to financial obligations?',
  ca_q21: '4. What is the estimated value of your Assets?',
  ca_q22: '5. What is the structure of your Assets?',
  ca_q23: '6. What is your estimated Net Worth (Total Assets – Total Liabilities)?',
  ca_q24: '1. Please select one of the below statements:',
  ca_q25: '2. Which of the following statement is more appropriate for you?',
  ca_q26: '3. Which is most relevant to your investment style?',
  ca_q27: '4. Based on your expectations what is the annual fluctuation of your portfolio’s value that you are willing to accept?',
  ca_q28: '5. Which of the following options will be considered as the most appropriate portfolio for you?',
  ca_q29: '6. What is the time horizon of your investment objectives?',
  ca_q30: '7. What is your investment goal?',
  ca_q31: '8. What is the liquidity level of your portfolio that you are willing to accept?',

  ca_q1_ao1: 'a) Yes, I have traded on a real account',
  ca_q1_ao2: 'b) Yes, I have traded on a demo account',
  ca_q1_ao3: 'c) No, but I have used the investment services of Portfolio Management and/or Investment Advice',
  ca_q1_ao4: 'd) No, but I have extensive knowledge through my education (bachelor’s degree, master’s degree etc.)',
  ca_q1_ao5: 'e) No',
  ca_q2_ao6: 'a) 0 - 6 months',
  ca_q2_ao7: 'b) 6 - 12 months',
  ca_q2_ao8: 'c) 1 - 2 years',
  ca_q2_ao9: 'd) 2 - 4 years',
  ca_q2_ao10: 'e) Over 4 years',
  ca_q3_ao11: 'I. Never',
  ca_q3_ao12: 'II. Rarely (less than 50 times)',
  ca_q3_ao13: 'III. Sometimes (50-100 times)',
  ca_q3_ao14: 'IV. Frequently (more than 101 trades)',
  ca_q4_ao15: 'I. Never',
  ca_q4_ao16: 'II. Rarely (less than 50 times)',
  ca_q4_ao17: 'III. Sometimes (50-100 times)',
  ca_q4_ao18: 'IV. Frequently (more than 101 trades)',
  ca_q5_ao19: 'I. Never',
  ca_q5_ao20: 'II. Rarely (less than 50 times)',
  ca_q5_ao21: 'III. Sometimes (50-100 times)',
  ca_q5_ao22: 'IV. Frequently (more than 101 trades)',
  ca_q6_ao23: 'I. Never',
  ca_q6_ao24: 'II. Rarely (less than 50 times)',
  ca_q6_ao25: 'III. Sometimes (50-100 times)',
  ca_q6_ao26: 'IV. Frequently (more than 101 trades)',
  ca_q7_ao27: 'i. 0',
  ca_q7_ao28: 'ii. Less than €500',
  ca_q7_ao29: 'iii. €501 - €2,000',
  ca_q7_ao30: 'iv. €2,001 - €5,000',
  ca_q7_ao31: 'v. More than €5,001',
  ca_q8_ao32: 'i. 0',
  ca_q8_ao33: 'ii. Less than €500',
  ca_q8_ao34: 'iii. €501 - €2,000',
  ca_q8_ao35: 'iv. €2,001 - €5,000',
  ca_q8_ao36: 'v. More than €5,001',
  ca_q9_ao37: 'i. 0',
  ca_q9_ao38: 'ii. Less than €500',
  ca_q9_ao39: 'iii. €501 - €2,000',
  ca_q9_ao40: 'iv. €2,001 - €5,000',
  ca_q9_ao41: 'v. More than €5,001',
  ca_q10_ao42: 'i. 0',
  ca_q10_ao43: 'ii. Less than €500',
  ca_q10_ao44: 'iii. €501 - €2,000',
  ca_q10_ao45: 'iv. €2,001 - €5,000',
  ca_q10_ao46: 'v. More than €5,001',
  ca_q11_ao47: 'a. Reception and transmission and/or execution of orders (investments services that require independent decisions)',
  ca_q11_ao48: 'b. Investment advice',
  ca_q11_ao49: 'c. Portfolio Management',
  ca_q11_ao50: 'd. None',
  ca_q12_ao51: 'a. I have relevant professional experience',
  ca_q12_ao52: 'b. I regularly monitor the news/markets',
  ca_q12_ao53: 'c. I have attended a seminar or course related to Financial Markets / Investments / Online Trading',
  ca_q12_ao54: 'd. None of the above',
  ca_q13_ao55: 'a. -€1,200',
  ca_q13_ao56: 'b. -€1,400',
  ca_q13_ao57: 'c. -€1,600',
  ca_q13_ao58: 'd. -€1,800',
  ca_q14_ao59: 'a. -€6,000',
  ca_q14_ao60: 'b. -€7,000',
  ca_q14_ao61: 'c. -€8,000',
  ca_q14_ao62: 'd. -€10,000',
  ca_q15_ao63: 'a. Protects you from suffering rapid losses',
  ca_q15_ao64: 'b. Limits your risk exposure',
  ca_q15_ao65: 'c. Ensures you never make a loss on a trade',
  ca_q15_ao66: 'd. Protects you from the risk of using leverage',
  ca_q16_ao67: 'a. If the price of the underlying on an open position moves against you in order for your equity to move below your minimum maintenance margin.',
  ca_q16_ao68: 'b. If you incur transaction fees which put your account into deficit.',
  ca_q16_ao69: 'c. If an open CFD position incurs overnight charges that puts your account into deficit.',
  ca_q16_ao70: 'd. All of the above.',
  ca_q17_ao71: 'a. -$100 or $300',
  ca_q17_ao72: 'b. -$200 or $600',
  ca_q17_ao73: 'c. -$2,000 or $6,000',
  ca_q17_ao74: 'd. -$4,000 or $12,000',
  ca_q18_ao75: 'a. Less than €20,000',
  ca_q18_ao76: 'b. Between €20,000 and €50,000',
  ca_q18_ao77: 'c. Between €50,000 and €100,000',
  ca_q18_ao78: 'd. More than €100,000',
  ca_q19_ao79: 'a. Salary/ Pension',
  ca_q19_ao80: 'b. Dividends/ Interest/ Coupons',
  ca_q19_ao81: 'c. Rents',
  ca_q19_ao82: 'd. Donations/ Inheritance',
  ca_q19_ao83: 'e. Other source of income',
  ca_q20_ao84: 'a. Less than 25%',
  ca_q20_ao85: 'b. Between 25% and 50%',
  ca_q20_ao86: 'c. Between 50% and 75%',
  ca_q20_ao87: 'd. More than 75%',
  ca_q21_ao88: 'a. Less than €100,000',
  ca_q21_ao89: 'b. Between €100,000 and €500,000',
  ca_q21_ao90: 'c. Between €500,000 and €1,000,000',
  ca_q21_ao91: 'd. More than €1,000,000',
  ca_q22_ao92: 'a. Mainly in Bank deposits',
  ca_q22_ao93: 'b. Mainly in Real estate',
  ca_q22_ao94: 'c. Mainly in Financial Instruments',
  ca_q22_ao95: 'd. Allocated equally in all three of the above options',
  ca_q22_ao96: 'e. Other',
  ca_q23_ao97: 'a. Less than €100,000',
  ca_q23_ao98: 'b. Between €100,000 and €500,000',
  ca_q23_ao99: 'c. Between €500,000 and €1,000,000',
  ca_q23_ao100: 'd. More than €1,000,000',
  ca_q24_ao101: 'a. I only take risks that might decrease my invested capital under extreme circumstances.',
  ca_q24_ao102: 'b. I can risk a part of my invested capital in order to reach a higher than average return.',
  ca_q24_ao103: 'c. I can risk a part or entire of my invested capital, hoping that I will get higher returns.',
  ca_q25_ao104: 'a. The most important to me is the safety of my capital. Thus, in order to avoid any loss, I am ready to give up higher returns',
  ca_q25_ao105: 'b. In order to get higher returns than average, I accept taking higher risks and I am ready to accept the slight decrease of my capital.',
  ca_q25_ao106: 'c. For high returns I am ready to take high risks even if a part or whole of my capital is at risk.',
  ca_q26_ao107: 'a. Capital preservation',
  ca_q26_ao108: 'b. Income growth',
  ca_q26_ao109: 'c. Speculation',
  ca_q26_ao110: 'd. Hedging',
  ca_q27_ao111: 'a. ± 5%',
  ca_q27_ao112: 'b. ± 10%',
  ca_q27_ao113: 'c. ± 25%',
  ca_q27_ao114: 'd. ± 50%',
  ca_q28_ao115: 'a. The one that will produce a stable 1 - 2% return in the next years.',
  ca_q28_ao116: 'b. The one that will produce returns between -2% and +10% in the next years.',
  ca_q28_ao117:
    'c. The one that is expected to produce returns between -15% and +30% in the next year and may even lead to a loss exceeding the invested amount under extreme conditions.',
  ca_q29_ao118: 'a. Up to 1 year',
  ca_q29_ao119: 'b. Between 1 and 3 years',
  ca_q29_ao120: 'c. Between 3 and 5 years',
  ca_q29_ao121: 'd. More than 5 years',
  ca_q30_ao122: 'a. Short term liquidity management in order to cover unexpected expenses.',
  ca_q30_ao123: 'b. Long term savings.',
  ca_q30_ao124: 'c. Make high profits even at the risk to lose the invested amount',
  ca_q31_ao125: 'a. Less than 25%',
  ca_q31_ao126: 'b. Between 25% and 50%',
  ca_q31_ao127: 'c. Between 50% and 75%',
  ca_q31_ao128: 'd. More than 75%',

  passport_ple_different: 'In case that your country of residence and the country of issue of your ID are different, please upload your Passport.',

  live_account: 'Live Account',
  agree_terms_marketing: 'I agree to receive marketing updates from Eurotrader (view <a href="{PRIVACY_URL}" target="_blank">Privacy Policy</a> ).',
  data_policy_text:
    'Your data is safe with us, and you can unsubscribe at any time. By clicking below, you are confirming that you have read and accepted the <a href="{TERMS_CONDITIONS_URL}" target="_blank">T&Cs</a> and <a href="{RISK_DISCLOSURE_URL}" target="_blank"> risk disclosure</a> and you consent to us storing and processing your personal information.',
  live_tos_with_link: 'I have read, understood and accepted the terms and conditions and risk warning disclosure <a href="{URL}" target="_blank">here</a>.',
  must_agree_marketing_terms: 'Please tick the checkbox to proceed to the next step',
  tick_checkboxes: 'Please tick the checkboxes to proceed',
  partner_account: 'Partner Account',
  privacy_policy: 'privacy policy',
  client: 'client',
  commission_amount: 'commission amount',
  tier_name: 'tier name',
  trades_completed: 'trades completed',
  trade: 'trade',
  pamm_investor_selection_note:
    "* Please note 'Investor accounts' are specifically designed to be used in connection with a Master account and cannot be traded on manually. Please contact customer support if you would like to know more about investor accounts",
  bitpace_network_warning_BTC: 'This address is for Bitcoin deposits only. Do not send from any chains other than BTC or your deposit may be lost',
  bitpace_network_warning_LTC: 'This address is for Litecoin deposits only. Do not send from any chains other than LTC or your deposit may be lost',
  bitpace_network_warning_XRP: 'This address is for Ripple deposits only. Do not send from any chains other than XRP or your deposit may be lost',
  bitpace_network_warning_BCH: 'This address is for Bitcoin Cash deposits only. Do not send from any chains other than BCH or your deposit may be lost',
  bitpace_network_warning_USDT:
    'Please use Ethereum (ERC20) or TRON (TRC20) networks only. Your deposit will be lost and unrecoverable if you do not use the specified networks. Please do not send funds via BSC, BEP20, BEP-2 or other networks.',
  bitpace_network_warning_USDC:
    'Please use Ethereum (ERC20) or TRON (TRC20) networks only. Your deposit will be lost and unrecoverable if you do not use the specified networks. Please do not send funds via BSC, BEP20, BEP-2 or other networks.',
  bitpace_network_warning_TRX:
    'Please use TRON (TRC20) network only. Your deposit will be lost and unrecoverable if you do not use the TRON network. Please do not send funds via BSC, BEP20, BEP-2 or other networks.',
  bitpace_network_warning_LINK:
    'Please use Ethereum (ERC20) network only. Your deposit will be lost and unrecoverable if you do not use the Ethereum network. Please do not send funds via BSC, BEP20, BEP-2, TRC or other networks.',
  crypto_note_text:
    "Dear client,<br /><br />We're delighted to share that our crypto deposit and withdrawal have been updated with a selection of coins to choose from, including Ethereum, Ripple, Litecoin and more. Thank you so much for your patience, and we apologise for any inconvenience caused.<br /><br /><strong>Please note: you need to click on 'Create address' and copy the latest address every time you want to deposit.</strong>",
  crypto_visit_page: 'Always visit this page to get the latest crypto address before depositing.',
  pamm_statistics_text:
    'Pamm Statistics are available at our PAMM Clientarea. If you have a PAMM account, please click the link below to be redirected, and use your PAMM account credentials to login.',
  leverage: 'Leverage',
  bitpace_network_warning_BTC_withdrawal: 'Please make sure the wallet address entered is correct and it’s in BTC. Entering the wrong address will cause your funds to be lost.',
  bitpace_network_warning_LTC_withdrawal: 'Please make sure the wallet address entered is correct and it’s in LTC. Entering the wrong address will cause your funds to be lost.',
  bitpace_network_warning_XRP_withdrawal: 'Please make sure the wallet address entered is correct and it’s in XRP. Entering the wrong address will cause your funds to be lost.',
  bitpace_network_warning_BCH_withdrawal: 'Please make sure the wallet address entered is correct and it’s in BCH. Entering the wrong address will cause your funds to be lost.',
  bitpace_network_warning_USDT_withdrawal:
    'Please make sure the wallet address entered is correct and its in ERC20 or TRC20 networks and it’s in USDT. Entering the wrong address will cause your funds to be lost.',
  bitpace_network_warning_USDC_withdrawal:
    'Please make sure the wallet address entered is correct and its in ERC20 or TRC20 networks and it’s in USDC. Entering the wrong address will cause your funds to be lost.',
  bitpace_network_warning_TRX_withdrawal:
    'Please make sure the wallet address entered is correct and its in TRC20 network and it’s in TRX. Entering the wrong address will cause your funds to be lost.',
  bitpace_network_warning_LINK_withdrawal:
    'Please make sure the wallet address entered is correct and its in ERC20 or TRC20 networks and it’s in LINK. Entering the wrong address will cause your funds to be lost.',
  payneteasy_note_text:
    'Please note that withdrawals via PNE are currently down for maintenance; if you require a withdrawal having deposited via PNE, please request a bank wire transfer. For Indonesian clients we will require a bank statement as well as clearing code and/or SWIFT code',
  payretailers_pix_key: 'PIX Key',
  important_information: 'Important Information',
  important_information_text: 'Based on your country of residence, your trading account will be registered with Eurotrade Investments RGB Ltd which is regulated by the Cyprus Securities Exchange Commission (CySEC).'
}



// WEBPACK FOOTER //
// ./src/locale/en.js